import { supabase } from '@/core/database/supabase';
import { roleLabels, UserRole } from '@/config/navigation.config';
import { enforceSettingsPermission } from '@/modules/settings/permissions/enforceSettingsPermission';
import type { MemberDetail, MemberLog } from '../types/memberDetail.types';

export const memberDetailService = {
  async getMemberById(id: string): Promise<MemberDetail> {
    await enforceSettingsPermission('settings.members.view');
    const { data, error } = await supabase
      .from('user_profiles')
      .select(`
        id,
        full_name,
        email,
        phone,
        avatar_url,
        status,
        created_at,
        role_code
      `)
      .eq('id', id)
      .single();

    if (error) throw error;

    // Mapping Supabase schema to our MemberDetail type
    return {
      id: data.id,
      fullName: data.full_name,
      email: data.email,
      phone: data.phone || '',
      avatarPath: data.avatar_url,
      status: data.status,
      roleCode: data.role_code || 'member',
      roleName: roleLabels[data.role_code as UserRole] || data.role_code || 'Thành viên',
      groupName: 'Chưa phân nhóm',
      joinDate: data.created_at,
      department: 'Phòng kỹ thuật', 
      permissions: ['view_projects', 'edit_tasks'], 
    };
  },

  async getMemberLogs(id: string): Promise<MemberLog[]> {
    // Mocking logs for now
    return [
      { id: '1', action: 'Đăng nhập hệ thống', timestamp: new Date().toISOString() },
      { id: '2', action: 'Cập nhật hồ sơ', timestamp: new Date(Date.now() - 86400000).toISOString() },
    ];
  }
};
